import * as fromDatatype from '../datatype-library/index';

export interface Bl_inv_stock_take_session_record_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_session_hdr: fromDatatype.GuidDataFieldInterface;
  guid_session_device: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  guid_bin: fromDatatype.VarcharDatatypeInterface;
  input_type: fromDatatype.VarcharDatatypeInterface;
  input_string: fromDatatype.TextDatatypeInterface;
  input_json: fromDatatype.JsonDatatypeInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_lastupdated: fromDatatype.TimestampTzDatatypeInterface;
  item_guid: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  base_uom: fromDatatype.VarcharDatatypeInterface;
  qty_uom: fromDatatype.NumericDatatypeInterface;
  ean_code: fromDatatype.VarcharDatatypeInterface;
  uom_ratio: fromDatatype.NumericDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
}

export class Bl_inv_stock_take_session_record_RowClass implements Bl_inv_stock_take_session_record_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_session_hdr: fromDatatype.GuidDataFieldInterface;
  guid_session_device: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  guid_bin: fromDatatype.VarcharDatatypeInterface;
  input_type: fromDatatype.VarcharDatatypeInterface;
  input_string: fromDatatype.TextDatatypeInterface;
  input_json: fromDatatype.JsonDatatypeInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_lastupdated: fromDatatype.TimestampTzDatatypeInterface;
  item_guid: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  base_uom: fromDatatype.VarcharDatatypeInterface;
  qty_uom: fromDatatype.NumericDatatypeInterface;
  ean_code: fromDatatype.VarcharDatatypeInterface;
  uom_ratio: fromDatatype.NumericDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
}
